export const CV_FILE_SIZE = 2 * 1024 * 1024;

export const CV_SUPPORTED_FORMATS = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/zip',
];
